export default __webpack_public_path__ + "static/Rolling-1s-200px-30c2cca9a0ad1d54b4905686b1e58a8f.gif";